import { render, staticRenderFns } from "./resumo-docs-rejeitados.vue?vue&type=template&id=733fb4e5&scoped=true"
import script from "./resumo-docs-rejeitados.vue?vue&type=script&lang=js"
export * from "./resumo-docs-rejeitados.vue?vue&type=script&lang=js"
import style0 from "./resumo-docs-rejeitados.vue?vue&type=style&index=0&id=733fb4e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733fb4e5",
  null
  
)

export default component.exports